import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import LinkButton from 'atoms/LinkButton';
import Image from 'next/image';
import React from 'react';

import s from './PortfolioEmpty.module.scss';

interface PortfolioEmptyProps {
  title: string;
  description: string;
  link?: string;
  linkText?: string;
  hideLearnMore?: boolean;
}

const PortfolioEmpty = ({
  title,
  description,
  link,
  linkText,
  hideLearnMore
}: PortfolioEmptyProps) => (
  <div className={s.PortfolioEmpty}>
    <div className={s.PortfolioEmpty__imageHolder}>
      <Image
        src="/images/portfolio_empty.png"
        alt="visual"
        width={200}
        height={200}
        priority={true}
      />
    </div>
    <Typography mb={2} variant="h2" className={s.PortfolioEmpty__title}>
      {title}
    </Typography>
    <Typography variant="caption" mb={4}>
      {description}
    </Typography>
    {link && linkText && (
      <LinkButton href={link} className={s.PortfolioEmpty__link}>
        {linkText}
      </LinkButton>
    )}
    {!hideLearnMore && (
      <Link
        color="text.secondary"
        target="_blank"
        href="https://www.usremsecurities.com/category/support/education/"
        className={s.PortfolioEmpty__learnMore}
      >
        Learn more about investing
      </Link>
    )}
  </div>
);

export default PortfolioEmpty;
